import { useTranslation } from 'react-i18next';

import { getStatusTranslationKey } from 'bringg-web/utils/get-translation-key';

export default function TaskStatus({ status }: { status: number }) {
	const { t } = useTranslation();

	return <div>{t(getStatusTranslationKey(status))}</div>;
}
